import { CommonModule } from '@angular/common'
import { Component, Input, ViewEncapsulation } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'

@Component({
  selector: 'ddc-store-card',
  templateUrl: './ddc-store-card.component.html',
  styleUrls: ['./ddc-store-card.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcStoreCardComponent {
  @Input() icon: string = ''
  @Input() title: string = ''
  @Input() subtitle: string = ''
  @Input() colorClass: string = ''
  @Input() lingoBadgeSrc: string = ''
}
